/**
 * @generated SignedSource<<7bfcee0dfb23a2020dec682786ec47f8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueType_nativeIssueTable_IssueTypeCell$data = {
  readonly issueType: {
    readonly avatar: {
      readonly small: string | null | undefined;
    } | null | undefined;
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentType": "issueType_nativeIssueTable_IssueTypeCell";
};
export type issueType_nativeIssueTable_IssueTypeCell$key = {
  readonly " $data"?: issueType_nativeIssueTable_IssueTypeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueType_nativeIssueTable_IssueTypeCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueType_nativeIssueTable_IssueTypeCell",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "small"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraIssueTypeField"
};

(node as any).hash = "e81709c5f121dd64c1bf41498bda4ae0";

export default node;
